module.exports = __webpack_public_path__ + "img/logo-mobile.5b056b71.png";